'use strict';

import { webUtils } from "./web-utils";

function handleErrorDuringDirectJoin(internalErrorMsg) {
    console.error(internalErrorMsg);

    const $error = $('.error-copy-container').show().first();
    $(window).scrollTop(0);
    $error.trigger('focus');
}

$('#easySetupForm, .sb-direct-join-form, .blue-cross-blue-shield-arizona-kitchen-join-form').on('submit', function (e) {
    e.preventDefault();

    let $form = $(this);
    let $lightVersion = !!$form.hasClass('light-version');

    // Reset Parsley validation completely
    $form.parsley().reset();
    
    // Also manually remove any error UI elements (for extra certainty)
    $form.find('.parsley-errors-list').remove();
    $form.find('.parsley-error, .parsley-success').removeClass('parsley-error parsley-success');
    
    if (!$form.parsley().isValid()) {
        return false;
    }

    let $submitButton = $('[type=submit]', $form);
    let cfg = webUtils.getSunbasketConfig();

    $submitButton.disableButton();

    webUtils.getCsrfToken(function (csrfResponse) {
        let data = {};

        if (!$lightVersion) {
            data.firstName = $form.find('input[name="firstName"]').val();
            data.lastName = $form.find('input[name="lastName"]').val();
            data.password = $form.find('input[name="password"]').val();
            data.confirmationPassword = $form.find('input[name="confirmationPassword"]').val();
        }

        data.email = $form.find('input[name="email"]').val();
        data.zip = $form.find('input[name="zip"]').val();

        let formTypeInput = $form.find('#formType');
        data.formType = formTypeInput.length ? formTypeInput.val() : 'default';

        let originInput = $form.find('#origin');
        data.origin = originInput.length ? originInput.val() : 'heroPromo';

        data.lightForm = $lightVersion;

        let promoCodeInput = $form.find('input[name="promoCode"]');
        let promoCodeValue = promoCodeInput.val();

        if (promoCodeInput) {
            const isSingleUse = promoCodeInput.data("singleUsePromoKey");
            
            if (isSingleUse) {
                data.promoCode = promoCodeValue;
                data.acceptOnlySingleUsePromoKey = true;
                
                // Check if validateSingleUsePromo is enabled
                if (promoCodeInput.data("validateSingleUsePromo")) {
                    data.validateSingleUsePromoKey = true;
                }
            } else if (promoCodeValue) {
                webUtils.setCookie('offer', promoCodeValue, false);
            }
        }

        let targetUrl = webUtils.getAjaxUrl('/cms/api/join');

        if(data.password && data.password.length > 0) {
            webUtils.setCookie('skipPassword', 'true', 1); // 1 day expiration
        }

        $.ajax({
            url: targetUrl,
            data: JSON.stringify(data),
            contentType: 'application/json',
            type: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                [csrfResponse.headerName]: csrfResponse.token,
            },
        }).done(function (response, status, jqXHR) {
            if (jqXHR.status !== 204 && jqXHR.status !== 200) {
                handleErrorDuringDirectJoin("Something went wrong while posting join form data to the CMS endpoint");
                return;
            }

            if (response && response.prospectId) {
                sessionStorage.setItem("prospectId", response.prospectId);
                localStorage.setItem("prospectId", response.prospectId); // Temporarily here, remove when everything settled
            }

            let targetPath = (response && response.redirectPath) || jqXHR.getResponseHeader('Location');
            if (!targetPath) {
                handleErrorDuringDirectJoin("Missing location header after posting join form data to the CMS endpoint");
                return;
            }

           
            window.location.href = webUtils.getAjaxUrl(targetPath);
        })// In the AJAX call's fail handler section
        .fail(function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status !== 400) {
                handleErrorDuringDirectJoin("Something went wrong while posting join form data to the CMS endpoint");
            } else {
                // First, clear all existing errors in the form
                $form.find('input').each(function() {
                    // Reset the Parsley UI completely
                    $(this).removeClass('parsley-error parsley-success');
                    // Remove the error list completely
                    const fieldId = $(this).attr('data-parsley-id');
                    if (fieldId) {
                        $('#parsley-id-' + fieldId).remove();
                    }
                });
                
                // Check if we received an error code for an invalid promo code
                if (jqXHR.responseJSON && jqXHR.responseJSON.errorCode === "PROMO_CODE_INVALID") {
                    // Get the promo code input field
                    let $promoCodeInput = $('input[name="promoCode"]', $form);
                    
                    // Add the error to the promo code field using parsley
                    $promoCodeInput.parsley().addError('custom-error', {
                        message: jqXHR.responseJSON.promoCode,
                        updateClass: true
                    });
                    
                    // Scroll to the promo code field
                    $('html, body').animate({
                        scrollTop: $promoCodeInput.offset().top - 40
                    }, 300);
                } else {
                    // Handle other validation errors as before
                    jQuery.each(jqXHR.responseJSON, function (key, value) {
                        $('input[name="' + key + '"]', $form).parsley().addError('custom-error', {
                            message: value,
                            updateClass: true
                        });
                    });
                }
        
                // Re-enable the submit button
                $submitButton.enableButton();
            }
        });
    }, function (error) {
        handleErrorDuringDirectJoin("Unable to get CSRF token: " + error);
    });
});

$(function() {
    $('.single-join-form').each(function() {
        const $singleJoinForm = $(this);
        let mealKitsSingleUrl = webUtils.getAjaxUrl('/join/mealkits');
        let freshReadySingleUrl = webUtils.getAjaxUrl('/join/fresh-ready');

        if ($singleJoinForm.hasClass('meal-kits-single')) {
            $singleJoinForm.attr('action', mealKitsSingleUrl);
        } else if ($singleJoinForm.hasClass('fresh-ready-single')) {
            $singleJoinForm.attr('action', freshReadySingleUrl);
        }

        $singleJoinForm.on('submit', function(e) {
            e.preventDefault();
            $('button[type=submit]', this).disableButton();

            let form = this;

            webUtils.getCsrfToken(function (csrfResponse) {
                $('#csrfToken', $singleJoinForm).val(csrfResponse.token);
                form.submit();
            });

            return false;
        });
    });
});
